//
import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from 'react-intl';

const NewsletterItem = (props) => {
  const url = "/frontend/nl_preview_window.aspx?idNL=" + props.item.IdMessage;
  return (
    <li className="">
      {props.item.LastUpdated && 
        <p className="frontend-elenco-email_note">{props.item.LastUpdated.StringValue.slice(0, 10)}</p>
      }
      <a className="frontend-elenco-email_subject" href={url} target="_blank">{props.item.Subject}</a>
    </li>
  );
};

NewsletterItem.propTypes = {
  item: PropTypes.shape({
    IdMessage: PropTypes.number.isRequired,
    IdList: PropTypes.number.isRequired,
    Subject: PropTypes.string.isRequired,
    Notes: PropTypes.string,
    LastUpdated: PropTypes.object
  })
};

export default injectIntl(NewsletterItem);
